import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { FeedsPage, feedStatusQueryOptions } from '@/features/feeds';
import { storeQueryOptions } from '@/features/stores';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/feeds')({
  staticData: { crumb: 'common:nav.feeds', tours: ['settings.feeds'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'content.read');
  },
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.query({ ...feedStatusQueryOptions(params.storeId), staleTime: 'static' }),
      context.queryClient.query({ ...storeQueryOptions(params.storeId), staleTime: 'static' }),
    ]).catch(() => undefined),
  component: FeedsPage,
});
